import { AgGridColumnProps } from "ag-grid-react";
import * as React from "react";
import { ExpiredQuote, localUserInfo, OrderModel } from "api";
import { asCurrency, asDate, asTimelessDateUTC, GridView } from "lqx-react";

export interface OrdersListProps {
  items: (OrderModel | ExpiredQuote)[];
  isOrdersView: boolean;
}

export const OrdersGrid = ({ items, isOrdersView }: OrdersListProps) => (
  <GridView
    exportEvent="orders:export"
    items={items}
    columnDefs={isOrdersView ? orderColumns : quoteColumns}
  />
);

function orderColumns(): AgGridColumnProps[] {
  const { isSupplier, isAdminRead } = localUserInfo;

  return [
    { headerName: "Status", field: "status" },

    ...(isSupplier || isAdminRead
      ? [{ headerName: "Distributor Name", field: "customerName" }]
      : []),

    ...(!isSupplier || isAdminRead
      ? [{ headerName: "Supplier Name", field: "supplier.name" }]
      : []),

    { headerName: "Quote #", field: "quote.id" },
    { headerName: "PO #", field: "po_number" },
    { headerName: "SO #", field: "sales_order_id" },
    {
      headerName: "Total Price",
      field: "total_price",
      cellStyle: { textAlign: "right" },
      valueFormatter: asCurrency
    },
    { headerName: "Flags", field: "displayFlags" },
    {
      headerName: "Creation Date",
      field: "created_on_utc",
      valueFormatter: asTimelessDateUTC
    }
  ];
}

function quoteColumns(): AgGridColumnProps[] {
  return [
    { headerName: "Quote #", field: "quote_id" },
    {
      headerName: "Creation Date",
      field: "quote_date",
      valueFormatter: asTimelessDateUTC
    },
    {
      headerName: "Expiration Date",
      field: "expiry_date",
      valueFormatter: asTimelessDateUTC
    }
  ];
}
